import importerActions from 'src/modules/shared/importer/importerActions';
import selectors from 'src/modules/responsibleConsumption/importer/responsibleConsumptionImporterSelectors';
import ResponsibleConsumptionService from 'src/modules/responsibleConsumption/responsibleConsumptionService';
import fields from 'src/modules/responsibleConsumption/importer/responsibleConsumptionImporterFields';
import { i18n } from 'src/i18n';

const responsibleConsumptionImporterActions = importerActions(
  'RESPONSIBLECONSUMPTION_IMPORTER',
  selectors,
  ResponsibleConsumptionService.import,
  fields,
  i18n('entities.responsibleConsumption.importer.fileName'),
);

export default responsibleConsumptionImporterActions;